import { render, staticRenderFns } from "./Orderdone.vue?vue&type=template&id=29d08e04&scoped=true&"
import script from "./Orderdone.vue?vue&type=script&lang=js&"
export * from "./Orderdone.vue?vue&type=script&lang=js&"
import style0 from "./Orderdone.vue?vue&type=style&index=0&id=29d08e04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d08e04",
  null
  
)

export default component.exports